import blocksInactive from './blocks-inactive.png';

interface Properties {
  width?: number;
  height?: number;
}

/**
 * Resting (inactive) state: icon exported directly from Figma (image 10,
 * node 74431:2223). Pairs with `BlocksIconActive` for the selected state.
 */
const BlocksIcon = ({ width = 16, height = 16 }: Properties) => {
  return <img src={blocksInactive} alt='' width={width} height={height} />;
};

export default BlocksIcon;
